// SurveyPhoneNumberQuestion.tsx
import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";
import { SurveyQuestionElementBase } from "survey-react-ui";
import { CountryCode } from "libphonenumber-js";
import { panelsName } from "../../panelsTitle";

export const getPhoneNumberProperties = [
  // { name: "answer", category: "general", visibleIndex: 0 },
];

interface State {
  value: string;
  country: CountryCode;
  exampleNumber: string;
  error: string | null;
}

export default class SurveyPhoneNumberQuestion extends SurveyQuestionElementBase {
  static defaultProps = {
    properties: getPhoneNumberProperties,
  };

  private phoneUtil: PhoneNumberUtil;

  constructor(props: any) {
    super(props);
    const raw = this.question.getPropertyValue("answer");
    this.phoneUtil = PhoneNumberUtil.getInstance();
    this.state = {
      value: "",
      country: "US" as CountryCode,
      exampleNumber: "",
      error: null,
      dialCode: "+1",
      isDisabled: false,
    };
  }

  get question() {
    return this.props.question!;
  }

  componentDidMount() {
    this.getExampleNumber(this.state.country);
    if (
      this.question.parent?.isPanel &&
      this.question.parent?.name === panelsName.ALERT_TRIGGER
    ) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  componentDidUpdate(prevProps: any, prevState: State) {
    const newQVal = this.props.question?.value || "";

    if (newQVal !== prevProps.question?.value && newQVal !== this.state.value) {
      this.setState({ value: newQVal }, () => {
        this.validateNumber(this.state.value);
      });
    }

    if (this.state.country !== prevState.country) {
      this.getExampleNumber(this.state.country);
      this.validateNumber(this.state.value);
    }
  }

  private async getExampleNumber(countryCode: CountryCode) {
    try {
      const ex = this.phoneUtil.getExampleNumber(countryCode);
      this.setState({
        exampleNumber: ex
          ? this.phoneUtil.format(ex, PhoneNumberFormat.INTERNATIONAL)
          : "Please Enter Your Number",
      });
    } catch {
      this.setState({ exampleNumber: "Please Enter Your Number" });
    }
  }

  private validateNumber(value: string) {
    if (!value) {
      this.setState({ error: null });
      return;
    }
    try {
      const parsed = this.phoneUtil.parse(value, this.state.country);
      const valid = this.phoneUtil.isValidNumber(parsed);
      // this.setState({ error: valid ? null : "Invalid phone number" });
    } catch {
      this.setState({ error: "Invalid phone number" });
    }
  }

  private handleChange = (newValue: string) => {
    this.setState({ value: newValue }, () => {
      this.validateNumber(newValue);
    });

    this.question.value = newValue;
    // // build your object exactly in the shape you want:
    // const dialCodeNum = this.phoneUtil.getCountryCodeForRegion(
    //   this.state.country
    // );
    const answerObj = {
      dialCode: `+${this.state.dialCode}`,
      isoCode: this.state.country,
      number: newValue || "",
    };
    if (
      this.question.parent?.isPanel &&
      this.question.parent?.name === panelsName.ALERT_TRIGGER
    ) {
      this.question.setPropertyValue("answer", newValue);
    } else {
      // this.question.setPropertyValue("answer", newValue);
    }
  };

  private handleCountryChange = (newCountry: CountryCode | undefined) => {
    if (newCountry) {
      const dialCode = this.phoneUtil.getCountryCodeForRegion(newCountry);
      this.setState({ country: newCountry, dialCode: dialCode });
    }
  };

  renderElement() {
    const { value, country, exampleNumber, error, isDisabled } = this.state;
    const isDesignMode = this.question.survey?._isDesignMode;
    return (
      <div style={{ width: "100%" }}>
        <PhoneInput
          international
          defaultCountry={country}
          country={country}
          value={
            typeof this.question.getPropertyValue("answer") === "object"
              ? this.question.getPropertyValue("answer").number
              : this.question.getPropertyValue("answer")
          }
          disabled={isDisabled || !isDesignMode}
          placeholder={exampleNumber}
          limitMaxLength
          onChange={this.handleChange}
          onCountryChange={this.handleCountryChange}
          style={{
            width: "100%",
            padding: "8px 12px",
            fontSize: "1rem",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />

        {/* {error !== null && (
          <p className="flex-grow capitalize w-[1/2] text-xs text-left text-accent_1Dark">
            {error}
          </p>
        )} */}
      </div>
    );
  }
}
